<template>
    <div class="pages">
        <div class="page">
            <div class="header">
                <h1><i :class="$options.icon"></i> {{ $t('dashboard.hello', {userFirstName: $store.state.auth.firstName}) }}</h1>
                <p>Subtitel van het eerste dashboard blok</p>
            </div>

            <br>
            <p>{{ $t("dashboard.welcome", {user: $store.state.auth.emailAddress}) }}</p>
        </div>

        <br>
        <br>

        <div class="page">
            <div class="header">
                <h1><i :class="$options.icon"></i> Tweede dashboard blok</h1>
                <p>Subtitel van het tweede dashboard blok</p>
            </div>

            <br>
            <p>Content voor het tweede dashboard blok</p>
        </div>

        <br>
        <br>

        <div class="page">
            <div class="header">
                <h1><i :class="$options.icon"></i> Derde dashboard blok</h1>
                <p>Subtitel van het derde dashboard blok</p>
            </div>

            <br>
            <p>Content voor het derde dashboard blok</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Dashboard',
        title: 'menu.dashboard',
        icon: 'fas fa-tachometer-alt',
        components: {}
    }
</script>
